import React from 'react';
import { PRICE } from '../data/salesContent';
export function PriceBlock({
  lead
}: {
  lead?: string;
}) {
  return <div className="text-center" data-id="element-42" data-mp="1yua0bo3nuprj">
      {lead && <p className="text-sm font-semibold uppercase tracking-[0.2em] text-ink-muted" data-id="element-43" data-mp="1yxo1wu4i2uxx">{lead}</p>}
      <p className="mt-2 font-serif text-5xl text-ink tabular-nums md:text-6xl" data-id="element-44" data-mp="2ct057pwq1tqg">{PRICE}</p>
      <p className="mt-3 text-base text-ink-muted" data-id="element-45" data-mp="27wt2e5zmgycq">Pago único · Acceso digital inmediato</p>
    </div>;
}